import { IRootStore } from '../store/rootStore';
import { BlockNormalized } from '../block/client';

import { normalizeInputCommentAdd } from './InputCommentAdd/normalizers';
import { normalizeActionSendMessage } from './ActionSendMessage';
import { normalizeActionSetVar } from './ActionSetVar';
import { normalizeActionUserInput } from './ActionUserInput';
import { normalizeActionExtractData } from './ActionExtractData';
import { normalizeActionSendStats } from './ActionSendStats';
import { normalizeActionExecuteSq } from './ActionExecuteSq';
import { normalizeActionAddToList } from './ActionAddToList';
import { normalizeActionRemoveFromList } from './ActionRemoveFromList';
import { normalizeActionHttpRequest } from './ActionHttpRequest';
import { normalizeActionNotifyManagers } from './ActionNotifyManagers';
import { normalizeConditionSwitch } from './ConditionSwitchCase';
import { normalizeConditionLlmClassification } from './ConditionLlmClassification';
import { normalizeConditionBasic } from './ConditionBasic';
import { normalizeConditionIsGroupMember } from './ConditionIsGroupMember';
import { normalizeInputMailing } from './InputMailing';
import { normalizeInputChatMessage } from './InputChatMessage';
import { normalizeActionReadGoogleSheets } from './ActionReadGoogleSheets';
import { normalizeActionSetCellGoogleSheets } from './ActionSetCellGoogleSheets';
import { normalizeActionAddRowGoogleSheets } from './ActionAddRowGoogleSheets';
import { BlockKind, normalizeCommonFields } from './common';
import { BlockServer } from './server';
import { normalizeActionSaveFileAttachment } from './ActionSaveFileAttachment';

export const normalizeBase = (
  raw: BlockServer,
  stores: { rootStore: IRootStore }
): BlockNormalized => {
  switch (raw.kind) {
    case BlockKind.chatMessage:
      return normalizeInputChatMessage(raw, stores);
    case BlockKind.preFilter:
      return normalizeCommonFields(raw, stores);
    case BlockKind.mailingSend:
      return normalizeInputMailing(raw, stores);
    case BlockKind.basic:
      return normalizeConditionBasic(raw, stores);
    case BlockKind.isGroupMember:
      return normalizeConditionIsGroupMember(raw, stores);
    case BlockKind.conditionSwitch:
      return normalizeConditionSwitch(raw, stores);
    case BlockKind.llmClassification:
      return normalizeConditionLlmClassification(raw, stores);
    case BlockKind.sendMessage:
      return normalizeActionSendMessage(raw, stores);
    case BlockKind.setVar:
      return normalizeActionSetVar(raw, stores);
    case BlockKind.userInput:
      return normalizeActionUserInput(raw, stores);
    case BlockKind.extractData:
      return normalizeActionExtractData(raw, stores);
    case BlockKind.sendStats:
      return normalizeActionSendStats(raw, stores);
    case BlockKind.randomChoice:
      return normalizeCommonFields(raw, stores);
    case BlockKind.executeSq:
      return normalizeActionExecuteSq(raw, stores);
    case BlockKind.addToList:
      return normalizeActionAddToList(raw, stores);
    case BlockKind.removeFromList:
      return normalizeActionRemoveFromList(raw, stores);
    case BlockKind.setTimer:
      return normalizeCommonFields(raw, stores);
    case BlockKind.notifyOperator:
      return normalizeCommonFields(raw, stores);
    case BlockKind.cancelEvent:
      return normalizeCommonFields(raw, stores);
    case BlockKind.httpRequest:
      return normalizeActionHttpRequest(raw, stores);
    case BlockKind.preFilterBreak:
      return normalizeCommonFields(raw, stores);
    case BlockKind.preFilterContinue:
      return normalizeCommonFields(raw, stores);
    case BlockKind.notifyManagers:
      return normalizeActionNotifyManagers(raw, stores);
    case BlockKind.readGoogleSheets:
      return normalizeActionReadGoogleSheets(raw, stores);
    case BlockKind.setCellGoogleSheets:
      return normalizeActionSetCellGoogleSheets(raw, stores);
    case BlockKind.addRowGoogleSheets:
      return normalizeActionAddRowGoogleSheets(raw, stores);
    case BlockKind.sendEmail:
      return normalizeCommonFields(raw, stores);
    case BlockKind.note:
      return normalizeCommonFields(raw, stores);
    case BlockKind.webhook:
      return normalizeCommonFields(raw, stores);
    case BlockKind.getCourseUserImport:
      return normalizeCommonFields(raw, stores);
    case BlockKind.getCourseDealImport:
      return normalizeCommonFields(raw, stores);
    case BlockKind.switchContext:
      return normalizeCommonFields(raw, stores);
    case BlockKind.commentAdd:
      return normalizeInputCommentAdd(raw, stores);
    case BlockKind.webAppData:
      return normalizeCommonFields(raw, stores);
    case BlockKind.amoCRMAddLead:
      return normalizeCommonFields(raw, stores);
    case BlockKind.amoCRMEditLead:
      return normalizeCommonFields(raw, stores);
    case BlockKind.bitrix24AddDeal:
      return normalizeCommonFields(raw, stores);
    case BlockKind.bitrix24EditDeal:
      return normalizeCommonFields(raw, stores);
    case BlockKind.portalIn:
      return normalizeCommonFields(raw, stores);
    case BlockKind.portalOut:
      return normalizeCommonFields(raw, stores);
    case BlockKind.communicateAI:
      return normalizeCommonFields(raw, stores);
    case BlockKind.askGpt:
      return normalizeCommonFields(raw, stores);
    case BlockKind.tgSendDice:
      return normalizeCommonFields(raw, stores);
    case BlockKind.kickFromChat:
      return normalizeCommonFields(raw, stores);
    case BlockKind.sendLeaderboard:
      return normalizeCommonFields(raw, stores);
    case BlockKind.saveFileAttachment:
      return normalizeActionSaveFileAttachment(raw, stores);
  }
};
